<template>
	<div>
		<nk-dropdown v-model="dropdownValue" @selector-opened="prepareCentersList" ref="dropdown" :data="dropdownData" :disabled="isDisabled ? true : null" :options="dropdownOptions" :tabindex="tabindex"></nk-dropdown>
		<div class="w-100 d-flex justify-content-between" v-if="settings.showSelectedBalance && dropdownValue">
			<nk-label @click="turnOver" :modelValue="accessShowCenterBalance ? dropdownValue.balance : '***'" :options="{ type: accessShowCenterBalance ? 'balance' : 'string', nature: nature }" class="font-weight-bold center-balance"></nk-label>
		</div>
	</div>
</template>
<script>
	import _ from 'lodash'
	import { mapGetters, mapActions } from 'vuex'
	import emptyId from '~/statics/empty-id'
	import Endpoints from '@nikan/endpoints'
	import FloatingCenterAdvanceName from '~/components/form/floating-center-advance-name'
	import CenterModify from '~/views/floating-centers/modify.vue'
	import CenterList from '~/views/floating-centers/center-selector.vue'
	import $sc from '~/plugins/shortcut.collection.js'
	import { post } from '~/plugins/nikan-api'
	import AutoAccountSelector from '~/components/account/auto-account-selector'
	import { isEmpty } from '~/statics/validators.js'
	import { FloatingCenterGroups } from '@/enums/system'
	import { defineAsyncComponent } from 'vue'

	export default {
		name: 'dropdown-floating-center',
		props: {
			data: { type: Array, deafult: () => [] },
			modelValue: {},
			options: {},
			disabled: { type: Boolean, default: false },
			tabindex: {},
			group: { type: Array },
			roles: { 
				type: Array,
				required: false
			 },
		},
		emits: ['update:modelValue', 'dataChanged'],
		data() {
			return {
				baseAccountsArray: [],
				settings: {
					showSelectedBalance: true,
					hasChild: false,
					filter: {},
				},
				selectorLoading: null,
				selectorLoadingCounter: 0,
				dropdownOptions: {},
				dropdownData: [],
				localValue: null,
				currentLinkedCenters: null,
				addCenterBtn: {
					title: this.$t('trs.transaction.m.new-center'),
					shortcut: $sc.find('ctrl-insert'),
					isPrimary: false,
					element: () => { return this.$el },
					icon: 'plus',
					handle: (button, page, e) => {
						this.showCenterModify()
					}
				},
				listCenterBtn: {
					title: this.$t('list'),
					shortcut: $sc.find('enter'),
					isPrimary: true,
					element: () => { return this.$el },
					icon: 'list-ul',
					handle: (button, page, e) => {
						this.showCenterList(true)
					}
				},
				centersList: [],
				ready: false,
				localDisabled: false
			}
		},
		computed: {
			...mapGetters({
				findForm: 'forms/findFormByKey',
				getAutoAccountsItemsByKey: 'autoAccounts/getItemsByKey',
				getCentersByAccountId: 'floatingCenters/getCentersByAccountId',
				getFloatingCentersByAutoKey: 'autoAccounts/getFloatingCentersByAutoKey',
				getAllCenters: 'floatingCenters/all',
				isServerSide: 'floatingCenters/isServerSide',
				checkFloatingBalanceAccess: 'appContext/checkAccessFloatingCentersBalanceObserve',

			}),
			serverSideStatus() {
				return (this.baseAccountsArray.length > 3 || this.isServerSide) && !(this.data && this.data.length)
			},
			computedGroup() {
				return this.settings.group || this.group || []
			},
			computedroles() {
				return this.settings.roles || this.roles || []
			},
			factorType() {
				return this.settings.factorType || 'sale'
			},
			dropdownValue: {
				get() {
					return this.localValue
				},
				set(val) {
					this.localValue = val
					this.valueChanged(val)
				}
			},
			isDisabled() {
				return this.disabled || this.localDisabled
			},
			autoAccountTypeKeys() {
				let types = this.findForm(this.settings.formName)
					?.types.filter((x) => x.isDebtor === this.settings.isDebtor) || []

				types = types.reduce((arr, item) => {
					arr.push(item.key)
					return arr
				}, [])

				return types
			},
			accessShowCenterBalance() {
				return this.checkFloatingBalanceAccess && !this.dropdownValue?.balanceRestricted
			},
			nature() {
				return this.settings.nature || 'CreditorRemaining'
			}
		},
		watch: {
			options: {
				deep: true,
				immediate: true,
				handler(val, oldVal) {
					if (oldVal && ((this.settings.baseAccountId && val.baseAccountId !== this.settings.baseAccountId) || (this.settings.centerLevel && val.centerLevel !== this.settings.centerLevel))) {
						if (this.dropdownValue && val.baseAccountId && this.dropdownValue.relatedAccountsByLevel?.findIndex(x => x.accountId === val.baseAccountId && x.centerLevel === val.centerLevel) === -1) {
							this.dropdownValue = null
						}
					}
					if (!oldVal || val.baseAccountId !== this.settings.baseAccountId || val.centerLevel !== this.settings.centerLevel || val.group !== this.settings.group) {
						this.settings = _.merge(this.settings, val)
					}
					this.settings.baseAccountId = val.baseAccountId
					this.settings.excludeCenterIds = val.excludeCenterIds
					if (this.settings.centerLevel > 1)
						this.settings.autoSelectWhenOneItemExist = false
				}
			},
			centersList: {
				deep: true,
				handler() {
					this.cleanValue()
				}
			},
			modelValue: {
				deep: true,
				immediate: true,
				handler(val, oldVal) {
					this.localValue = _.cloneDeep(val)
				}
			},
			'$store.state.autoAccounts.autoAccounts': {
				deep: true,
				handler() {
					this.setBaseAccountArray()
					this.setDefaultFloatingCenter(this.getAllCenters)
				}
			}
		},
		created() {
			this.setDropDownOptions()
		},
		mounted() {
			this.settings = _.merge(this.settings, this.options)
			if (this.settings.centerLevel > 1)
				this.settings.autoSelectWhenOneItemExist = false
			this.cleanValue()
			if (!this.settings.hideDropDownBtn) {
				this.settings.dropdownOptions.buttons.push(this.listCenterBtn, this.addCenterBtn)
			}
		},
		methods: {
			...mapActions({
				getCentersByAccountIdAndItsParents: 'floatingCenters/getCentersByAccountIdAndItsParents',
				broadcastRefresh: 'socket/broadcastRefresh'
			}),
			setBaseAccountArray() {

				if (!this.settings.baseAccountId) {
					this.baseAccountsArray = []
				} else if (Array.isArray(this.settings.baseAccountId)) {
					this.baseAccountsArray = this.settings.baseAccountId
				} else if (this.settings.baseAccountId > emptyId) {
					this.baseAccountsArray = [this.settings.baseAccountId]
				} else {
					this.baseAccountsArray = []
				}
				this.setDropDownOptions()
			},
			calcDropdownData() {
				if (this.data && this.data.length) {
					this.dropdownData = this.data
					return
				}

				let result = this.centersList.filter(x => x?.hasChild === this.settings.hasChild && x.isEnabled)
				if (!this.settings.showIfRelatedAccountIsEmpty)
					result = result.filter(x => x.relatedAccountIds.length)

				if (this.settings.excludeCenterIds && this.settings.excludeCenterIds.length > 0)
					result = result.filter(x => !this.settings.excludeCenterIds.includes(x.id))

				if (this.computedGroup && this.computedGroup.length > 0)
					result = result.filter(x => this.computedGroup.includes(x.group))

				if (this.settings.filter?.clientSide)
					result = this.settings.filter.clientSide(result)

				if(this.computedroles && this.computedroles.length > 0 )
					result = result.filter(x => x.marketingRoles.some(role => this.computedroles.includes(role)))

				this.setDefaultFloatingCenter(result)

				this.$emit('dataChanged', result)
				this.dropdownData = result
			},
			setDefaultFloatingCenter(items) {
				if (this.settings.formName) {
					let defaultCenters = this.getFloatingCentersByAutoKey(this.autoAccountTypeKeys) || []
					this.localDisabled = false
					if (defaultCenters.length) {
						items = items.filter(x => defaultCenters.map(x => x.floatingCenter.id).includes(x.id))
						if (items.length === 1) {
							if (!this.modelValue)
								this.dropdownValue = items[0]
						} else {
							this.localDisabled = false
						}
					}
				}
			},
			setDropDownOptions() {
				const findMetaData = (metaDataField) => (data) => {
					const foundData = data?.metaDatas.find(x => x.metaDataSchema.systemField === metaDataField)
					return foundData?.value
				}

				const serverSideMetadata = (metDataField) => (value) => { return { systemField: metDataField, value: value } }

				this.settings.dropdownOptions = this.dropdownOptions = {
					...this.settings.dropdownOptions,
					disable: this.localDisabled,
					rowIdentifier: 'id',
					placeholder: this.$t('search'),
					buttons: [],
					selectorWidth: 420,
					selectorHeight: '50%',
					searchableFields: ['accountingCode', 'name', findMetaData('Center_Mobile'), findMetaData('Center_NationalCode')],
					autoSelectWhenOneItemExist: false,
					loadOnMount: true,
					display: (item) => `${item.name} (${item.accountingCode})`,//can't put code title here because of ltr and &lrm; not work here
					readOnlyDisplay: (item) => {
						return `${item.name} (${item.accountingCode})`
					},
					searchRequestFilter: (items, request) => {
						var ids = []
						if (items && items.length > 0) {
							for (var i = 0; i < items.length; i++) {
								ids.tryPush(items[i].position)
							}

							request.exceptPositions = ids
							request.relatedAccountId = this.baseAccountsArray[0]
						}
						return request
					},
					component: {
						type: 'ag-grid',
						options: {
							id: this.$options.name,
							paginationPageSize: 50,
							rowModelType: this.serverSideStatus ? 'serverSide' : 'clientSide',
							serverInfo: {
								api: {
									url: Endpoints.getUrl('floatingCenters.pageList'),
									manipulateResponse: (res) => {
										// console.log('manipulateResponse res',res)
										return {
											rowData: res.data.items,
											rowCount: res.data.totalCount
										}
									},
									manipulateRequest: (params, payload) => {
										if (!this.baseAccountsArray.length && !this.settings.loadAllIfBaseAccountIsEmpty) {
											const fakeRes = { data: { items: [], totalCount: 0 } }
											let url
											return { fakeRes, payload, url }
										}
									}
								},
								finally: () => {
								},
								searchableFields: this.settings.filter.searchableFields ? this.settings.filter.searchableFields : [serverSideMetadata('Center_Mobile'), serverSideMetadata('Center_NationalCode'),],
								payload: {
									baseAccountIds: this.baseAccountsArray?.length === 0 ? null : this.baseAccountsArray,
									centerLevel: this.settings.centerLevel ? this.settings.centerLevel : null,
									loadOnlyLeafs: !this.settings.hasChild,
									excludeCenterIds: this.settings.excludeCenterIds,
									groups: this.computedGroup.map(x => Object.keys(FloatingCenterGroups).indexOf(x) + 1),
									// if true, it means load centers which have at least one related account
									includeRelatedAccount: !this.settings.showIfRelatedAccountIsEmpty,
									includeAccounts: this.settings.includeAccounts,
									filter: {
										SchemaValues: [],
										...(typeof this.settings.filter.serverSide === 'function' ? this.settings.filter.serverSide() : this.settings.filter.serverSide),
										combineWithAnd: typeof this.settings.filter.combineWithAnd === 'boolean' ? this.settings.filter.combineWithAnd : false
									}
								}
							},
							columnDefs: [
								{
									field: 'accountingCode',
									headerName: this.$t('center.selector.table.c.accountingCode'),
									width: 30,
								},
								{
									field: 'name',
									headerName: this.$t('center.selector.table.c.name'),
									sortable: false,
									cellRenderer: FloatingCenterAdvanceName,
									cellRendererParams: (params) => {
										if (params.data) return {
											options: {
												advance: true,
												data: params.data,
												factorType: this.factorType,
											}
										}
									},
									width: 200,
								},
								{
									field: 'parentName',
									headerName: this.$t('center.selector.table.c.parent'),
									sortable: false,
									width: 150,
									contentType: 'enum',
									valueFormatter: params => {
										return params.data.parent?.name ? params.data.parent.name : null
									}
								},
							],
							rowSelection: {
								mode: 'singleRow'
							},
							cellSelectionAggReport: false,
							sideBar: 'none',
							enterToSelect: true,
							doubleClickedToSelect: true,
							pagination: false,
							fitToWidth: false
						},
					}
				}
			},
			checkAccounts() {
				return new Promise((resolve, reject) => {
					let accountId = this.settings.baseAccountId
					if (Array.isArray(accountId) && accountId.length > 1)
						this.showModal({
							component: AutoAccountSelector,
							options: {
								isDebtor: true,
								formName: this.settings.formName,
								typeKeys: this.findForm(this.settings.formName).types.map(x => x.key),
							},
						})
							.then(res => {
								accountId = res[this.settings.formName].id
								resolve(accountId)

							}).catch(err => { })
					else if (Array.isArray(accountId) && accountId.length === 1) {
						accountId = accountId[0]
						resolve(accountId)
					} else
						resolve(accountId)

				})
			},
			retreiveSelectedCenters(accountId) {
				let dataId = {
					AccountId: accountId,
				}

				return post(Endpoints.getUrl('accounts.centersLinkedToAccount'), dataId)
					.then((result) => {
						return result
						// this.selectedItems = this.prepareSelectedCenters(result.data.items)
						// return this.selectedItems
					})
					.finally(() => {
					})
			},
			showCenterList(updateBaseAccountId) {
				updateBaseAccountId && this.setBaseAccountArray()
				this.showModal({
					component: CenterList,
					data: this.dropdownData,
					options: {
						filterType: 'custom',
						selected: this.dropdownValue,
						serverSideStatus: this.serverSideStatus,
						centerLevel: this.settings.centerLevel,
						excludeCenterIds: this.settings.excludeCenterIds,
						includeRelatedAccount: !this.settings.showIfRelatedAccountIsEmpty,
						pageNumber: this.$refs.dropdown.$refs?.comp ? this.$refs.dropdown.$refs?.comp.pageNumber : 1,
						groups: this.computedGroup.map(x => Object.keys(FloatingCenterGroups).indexOf(x) + 1),
						baseAccountIds: this.baseAccountsArray
					}
				})
					.then((res) => {
						if (this.$refs.dropdown)
							this.$refs.dropdown.$el.focus()

						this.dropdownValue = res

					})
					.catch(err => {
						if (this.$refs.dropdown)
							this.$refs.dropdown.$el.focus()
					})
			},
			showCenterModify() {
				this.checkAccounts().then(accountId => {
					this.defer(() => {
						let centerLevel = this.settings.centerLevel

						if (!isEmpty(accountId))
							this.retreiveSelectedCenters(accountId).then(res => {
								this.currentLinkedCenters = res.data.items
							})
						else if (isEmpty(accountId) && this.settings.linkNewCenterToAccount)
							return this.$toast(this.$t('trs.transaction.m.select-account-first'), { type: 'info' })

						let data = {
							nodeData: {},
							parentData: null,
							state: 'add-root',
						}
						data.nodeData.level = centerLevel
						data.nodeData.relatedAccountsByLevel = []
						if (accountId) {
							data.nodeData.relatedAccountsByLevel = [{
								"accountId": accountId,
								"centerLevel": centerLevel,
								"rowState": "new",
								"displayOrder": 0,
								"id": emptyId
							}]
						}
						this.showModal({
							component: CenterModify,
							data: data,
							options: {
								group: this.settings.group,
								allowParents: true
							}
						})
							.then((res) => {
								if (this.$refs.dropdown)
									this.$refs.dropdown.$el.focus()

								this.dropdownValue = res


							}).catch(err => {
								if (this.$refs.dropdown)
									this.$refs.dropdown.$el.focus()
							})
					}, 500)
				}).catch(err => { })
			},
			findAccountsByAutoKey(keys) {
				let accounts = []
				if (!keys)
					return accounts

				for (let key of keys) {
					accounts.push(...this.getAutoAccountsItemsByKey(key))
				}

				accounts = accounts.reduce((list, current) => {
					if (list.findIndex(x => x.id === current.id) === -1) {
						list.push(current)
					}

					return list
				}, [])

				return accounts.map(x => x.id)
			},
			async prepareCentersList() {
				this.setBaseAccountArray()
				if (this.settings.formName && this.baseAccountsArray.length === 0)
					this.centersList = [].concat(this.settings.defaultCentersList)
				else if (this.serverSideStatus) return
				else if (this.baseAccountsArray.length > 0) {
					let promiseList = []
					for (let id of this.baseAccountsArray) {
						promiseList.push(this.getCentersByAccountIdAndItsParents({ accountId: id, centerLevel: this.settings.centerLevel }))
					}

					await Promise.all(promiseList)
						.then(values => {
							let mergeValues = values.reduce((a, c) => {
								let tamp = c.filter(x => x.hasChild === this.settings.hasChild)
								a = [...a, ...tamp]
								return a
							}, [])
							let list = [...new Map(mergeValues.map((item) => [item["id"], item])).values()]
							this.centersList = list.concat(this.settings.defaultCentersList ? this.settings.defaultCentersList : [])
						})
				} else {
					if (this.settings.loadAllIfBaseAccountIsEmpty)
						this.centersList = this.getAllCenters
					else
						this.centersList = []
				}
				this.tryEmptyValue()
				this.calcDropdownData()
			},
			tryEmptyValue() {
				// if (this.dropdownValue && this.centersList.findIndex(x => x.id === this.dropdownValue.id) === -1) {
				// 	this.dropdownValue = null
				// }
			},
			cleanValue() {
				if (this.modelValue && this.modelValue.length > 0) {
					let cleanedValue = this.modelValue.filter(v => this.centersList.filter(x => x.id === v.id).length > 0)
					if (this.modelValue.length !== cleanedValue.length) {
						this.$emit('update:modelValue', cleanedValue)
					}
				} else
					this.setDefaultFloatingCenter(this.getAllCenters)
			},
			valueChanged(val) {
				this.$emit('update:modelValue', val)
			},
			findExactMatch(list, text) {
				var filtered = list.filter(x => x.accountingCode === text)
				if (filtered.length === 1) {
					return filtered[0]
				}
			},
			turnOver() {
				this.showModal({
					component: defineAsyncComponent(() => import('~/views/reports/turn-over.vue')),
					data: null,
					options: {
						filter: { centers: [[this.dropdownValue]], level: 3, centerInAllLevels: true },
					},
				})
					.then((result) => { })
					.catch((err) => { })
			},
			focus() {
				this.$refs.dropdown.$el.focus()
			}
		},
	}
</script>
<style>
	.center-balance {
		font-size: 11px;
		cursor: pointer;
	}
</style>